module.exports = __webpack_public_path__ + "img/v2_qt4plq@2x.7ae1688c.png";